/**
 * Onautica Blog Carousel - Carosello dinamico prodotti per articoli Magefan/Bloggle
 * Si attiva solo su pagine /a/blog/post/ e mostra prodotti dalla collezione più rilevante
 * basandosi sul contenuto dell'articolo.
 */
(function() {
  'use strict';

  // Esegui solo su pagine blog Magefan
  if (!window.location.pathname.startsWith('/a/blog/post/')) return;

  // Mappa keyword → collection handle (ordine: più specifico prima)
  var KEYWORD_MAP = [
    { keywords: ['anodo', 'anodi', 'zinco sacrificale', 'zinchi', 'corrente galvanica', 'corrosione galvanica', 'protezione catodica'], handle: 'anodi-sacrificali-zinchi-barca', label: 'Anodi Sacrificali' },
    { keywords: ['antivegetativa', 'carena', 'carenaggio', 'opera viva', 'matrice dura', 'autolevigante', 'fouling'], handle: 'antivegetativa-autolevigante-matrice-dura', label: 'Antivegetativa' },
    { keywords: ['parabordo', 'parabordi', 'fender'], handle: 'parabordi-barca-cilindrici-sferici', label: 'Parabordi' },
    { keywords: ['luci navigazione', 'luci di via', 'fanali', 'luce segnalazione', 'colreg', 'led barca'], handle: 'luci-navigazione-segnalazione-barca', label: 'Luci di Navigazione' },
    { keywords: ['gps', 'plotter', 'ecoscandaglio', 'fishfinder', 'chartplotter', 'garmin', 'raymarine', 'lowrance'], handle: 'gps-plotter-ecoscandagli-fishfinder', label: 'GPS e Plotter' },
    { keywords: ['giubbotto salvataggio', 'giubbotto salvagente', 'salvagente', 'autogonfiabile', '150n', '100n', '275n'], handle: 'giubbotti-salvagente-aiuti-accessori', label: 'Giubbotti Salvagente' },
    { keywords: ['molla ormeggio', 'molle ormeggio', 'ammortizzatore ormeggio', 'ammortizzatori'], handle: 'molle-ormeggio-ammortizzatori', label: 'Molle e Ammortizzatori Ormeggio' },
    { keywords: ['olio motore', 'olio marino', 'lubrificante', 'tc-w3', 'fc-w', '10w-30', '15w-40'], handle: 'olio-motore-marino-4-tempi-2-tempi', label: 'Olio Motore Marino' },
    { keywords: ['razzo', 'razzi', 'estintore', 'estintori', 'kit sicurezza', 'dotazioni sicurezza', 'boetta luminosa'], handle: 'kit-sicurezza-razzi-estintori', label: 'Kit Sicurezza' },
    { keywords: ['bottazzo', 'profilo bottazzo', 'paracolpi barca', 'profilo pvc'], handle: 'bottazzo-barca-profili-gomma-inox-terminali', label: 'Bottazzi' },
    { keywords: ['copriparabordi', 'calze parabordi', 'copri parabordo'], handle: 'copriparabordi-calze-spugna', label: 'Copriparabordi' },
    { keywords: ['caricabatterie', 'inverter', 'victron', 'convertitore'], handle: 'gestione-conversione-caricabatterie-inverter', label: 'Caricabatterie e Inverter' },
    { keywords: ['vhf', 'radio nautica', 'antenna vhf'], handle: 'vhf-nautico-antenne-radio', label: 'VHF e Radio' },
    { keywords: ['timoneria', 'cavo timoneria', 'guaina timoneria'], handle: 'timonerie-cavi-accessori', label: 'Timonerie' },
    { keywords: ['bitta', 'bitte', 'galloccia', 'gallocce', 'passacavo', 'passacavi'], handle: 'bitte-ormeggio-passacavi-gallocce', label: 'Bitte e Passacavi' },
    { keywords: ['cima', 'cime', 'cavo ormeggio', 'treccia'], handle: 'cime-ormeggio-usi-vari', label: 'Cime' },
    { keywords: ['wc nautico', 'wc marino', 'toilette barca', 'wc elettrico', 'wc manuale'], handle: 'wc-nautici-elettrici-manuali-barca', label: 'WC Nautici' },
    { keywords: ['ancora', 'ancore', 'ancoraggio', 'musone', 'catena ancora'], handle: 'ancore-e-accessori', label: 'Ancore' },
    { keywords: ['pompa sentina', 'pompe sentina', 'sentina', 'svuotamento sentina'], handle: 'pompe-sentina-autoclavi-barca-autoadescanti', label: 'Pompe di Sentina' },
    { keywords: ['copribarca', 'telo copribarca', 'coprimotore', 'telo barca'], handle: 'teli-copribarca-coprimotore-rimessaggio', label: 'Copribarca' },
    { keywords: ['teak', 'coperta teak', 'pulizia teak', 'olio teak', 'manutenzione teak'], handle: 'trattamento-teak-olio-cleaner-nautica', label: 'Cura del Teak' },
    { keywords: ['ormeggio', 'ormeggiare', 'banchina', 'posto barca'], handle: 'molle-ormeggio-ammortizzatori', label: 'Ormeggio' },
    { keywords: ['salpancora', 'verricello', 'winch', 'argano'], handle: 'ancore-e-accessori', label: 'Ancore e Salpancora' },
    { keywords: ['rimessaggio', 'inverno', 'invernale', 'rimessare'], handle: 'teli-copribarca-coprimotore-rimessaggio', label: 'Copribarca e Rimessaggio' }
  ];

  /**
   * Trova la collezione migliore analizzando il testo dell'articolo
   */
  function findBestCollection() {
    // Raccogli testo da titolo, URL e contenuto articolo
    var title = (document.title || '').toLowerCase();
    var slug = window.location.pathname.split('/').pop().toLowerCase().replace(/-/g, ' ');

    // Testo articolo dal contenitore Magefan (.post-content) o fallback
    var articleEl = document.querySelector('.post-content') || document.querySelector('.main-content') || document.querySelector('.rte') || document.querySelector('article');
    var bodyText = articleEl ? articleEl.textContent.toLowerCase() : '';

    // Combina tutto in un unico testo di ricerca
    var fullText = title + ' ' + title + ' ' + slug + ' ' + slug + ' ' + bodyText;
    // Titolo e slug pesati doppio (ripetuti)

    var bestMatch = null;
    var bestScore = 0;

    for (var i = 0; i < KEYWORD_MAP.length; i++) {
      var entry = KEYWORD_MAP[i];
      var score = 0;

      for (var j = 0; j < entry.keywords.length; j++) {
        var kw = entry.keywords[j].toLowerCase();
        // Conta occorrenze
        var idx = 0;
        var count = 0;
        while ((idx = fullText.indexOf(kw, idx)) !== -1) {
          count++;
          idx += kw.length;
        }
        if (count > 0) {
          // Keyword più lunghe valgono di più (più specifiche)
          score += count * kw.length;
        }
      }

      if (score > bestScore) {
        bestScore = score;
        bestMatch = entry;
      }
    }

    // Soglia minima per evitare falsi positivi
    return bestScore >= 20 ? bestMatch : null;
  }

  /**
   * Formatta il prezzo in euro (il JSON restituisce stringhe tipo "19.64")
   */
  function formatPrice(priceStr) {
    var num = parseFloat(priceStr);
    if (isNaN(num)) return priceStr;
    return '€' + num.toFixed(2).replace('.', ',');
  }

  /**
   * Carica prodotti dalla collezione e renderizza il carosello
   */
  function loadAndRender(collection) {
    var url = '/collections/' + collection.handle + '/products.json?limit=8';

    fetch(url)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (!data.products || data.products.length === 0) return;
        renderCarousel(data.products, collection);
      })
      .catch(function(err) {
        console.warn('[Onautica Carousel] Errore caricamento prodotti:', err);
      });
  }

  /**
   * Renderizza il carosello nel DOM
   */
  function renderCarousel(products, collection) {
    // Trova il punto di inserimento: dopo il contenuto dell'articolo
    var articleEl = document.querySelector('.post-content') || document.querySelector('.main-content') || document.querySelector('.rte') || document.querySelector('article');
    if (!articleEl) return;

    // Se Magefan ha già "Prodotti Correlati", inserisci prima di quella sezione
    // Altrimenti inserisci dopo l'articolo
    var insertTarget = articleEl;
    var insertMethod = 'after'; // afterend

    // Crea il container
    var container = document.createElement('div');
    container.id = 'onautica-blog-carousel';
    container.style.cssText = 'margin-top:40px;padding:30px 0;border-top:2px solid #f0f0f0;';

    // Titolo
    var heading = document.createElement('h3');
    heading.style.cssText = 'font-size:1.3em;margin-bottom:20px;text-align:center;font-weight:700;color:#1a1a1a;';
    heading.textContent = 'Prodotti consigliati: ' + collection.label;
    container.appendChild(heading);

    // Scrollable row
    var row = document.createElement('div');
    row.style.cssText = 'display:flex;gap:16px;overflow-x:auto;padding:10px 0;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;';

    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var card = document.createElement('a');
      card.href = '/products/' + p.handle;
      card.style.cssText = 'scroll-snap-align:start;flex:0 0 200px;text-decoration:none;color:#1a1a1a;background:#fff;border:1px solid #eee;border-radius:8px;overflow:hidden;transition:box-shadow .2s;';
      card.onmouseover = function() { this.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; };
      card.onmouseout = function() { this.style.boxShadow = 'none'; };

      // Immagine
      if (p.images && p.images.length > 0) {
        var img = document.createElement('img');
        // Usa il formato ottimizzato Shopify
        var imgSrc = p.images[0].src;
        if (imgSrc.includes('?')) {
          imgSrc = imgSrc.split('?')[0];
        }
        img.src = imgSrc + '?width=300&height=300&crop=center';
        img.alt = p.title;
        img.loading = 'lazy';
        img.style.cssText = 'width:100%;height:180px;object-fit:contain;padding:10px;background:#fafafa;';
        card.appendChild(img);
      }

      // Info
      var info = document.createElement('div');
      info.style.cssText = 'padding:10px 12px;';

      var title = document.createElement('p');
      title.style.cssText = 'font-size:0.85em;margin:0 0 6px;line-height:1.3;height:2.6em;overflow:hidden;font-weight:500;';
      title.textContent = p.title.length > 55 ? p.title.substring(0, 52) + '...' : p.title;
      info.appendChild(title);

      // Prezzo
      var variant = p.variants && p.variants[0];
      if (variant) {
        var price = document.createElement('p');
        price.style.cssText = 'font-size:0.95em;margin:0;font-weight:700;color:#e63946;';
        price.textContent = formatPrice(variant.price);
        info.appendChild(price);

        if (variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
          var comparePrice = document.createElement('p');
          comparePrice.style.cssText = 'font-size:0.75em;margin:2px 0 0;color:#999;text-decoration:line-through;';
          comparePrice.textContent = formatPrice(variant.compare_at_price);
          info.appendChild(comparePrice);
        }
      }

      card.appendChild(info);
      row.appendChild(card);
    }

    container.appendChild(row);

    // CTA Button
    var ctaWrap = document.createElement('div');
    ctaWrap.style.cssText = 'text-align:center;margin-top:16px;';
    var cta = document.createElement('a');
    cta.href = '/collections/' + collection.handle;
    cta.style.cssText = 'display:inline-block;background:#1a1a1a;color:#fff;padding:12px 28px;border-radius:6px;text-decoration:none;font-weight:600;font-size:0.9em;transition:background .2s;';
    cta.onmouseover = function() { this.style.background = '#333'; };
    cta.onmouseout = function() { this.style.background = '#1a1a1a'; };
    cta.textContent = 'Vedi tutta la collezione →';
    ctaWrap.appendChild(cta);
    container.appendChild(ctaWrap);

    // Inserisci nel DOM
    insertTarget.parentNode.insertBefore(container, insertTarget.nextSibling);
  }

  // Esegui quando il contenuto Magefan è caricato
  function init() {
    var done = false;

    function tryRun() {
      if (done) return;
      var articleEl = document.querySelector('.post-content') || document.querySelector('.main-content');
      var len = articleEl ? articleEl.textContent.trim().length : 0;
      if (articleEl && len > 200) {
        done = true;
              var match = findBestCollection();
              if (match) {
          loadAndRender(match);
        }
      }
    }

    // Strategia 1: polling con molti tentativi (fino a 15 secondi)
    var attempts = 0;
    var maxAttempts = 60;
    function poll() {
      tryRun();
      if (!done && attempts < maxAttempts) {
        attempts++;
        setTimeout(poll, 250);
      }
    }
    poll();

    // Strategia 2: MutationObserver per reagire quando il contenuto viene iniettato
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function() {
        tryRun();
        if (done) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      // Timeout di sicurezza: disconnetti dopo 20 secondi
      setTimeout(function() { observer.disconnect(); }, 20000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
